import React from 'react';
import classNames from 'classnames';

import './TransitionSpinner.scss';

/**
 * Opens a modal progress spinner.
 */
interface TransitionSpinnerProps {
  /** Show the spinner. */
  show?: boolean;

  /** The text to display with the spinner. */
  text?: React.ReactNode;

  /** Hide the page covering mask. */
  hideMask?: boolean;

  /** Remove fixed position */
  inline?: boolean;

  /** A custom class name to add to the spinner */
  className?: string;

  /** Test ID attribute to add to the container */
  testID?: string;
}

const TransitionSpinner: React.FCWithChildren<TransitionSpinnerProps> = ({
  show = false,
  text,
  hideMask = false,
  className = '',
  testID,
  inline = false,
}) => (
  <div
    role="dialog"
    className={classNames(
      'transition-spinner-component',
      className,
      {
        inline,
        show,
        'show-mask': !hideMask,
        'has-text': (text && text !== ''),
      },
    )}
    data-testid={testID}
  >
    <span className="transition-spinner-content">
      {text}
    </span>
  </div>
);

export default TransitionSpinner;
